var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDeleteNotif(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.875 7.875H9.1875V15.75H7.875V7.875ZM11.8125 7.875H13.125V15.75H11.8125V7.875Z",
    fill: "#EC827D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.625 3.9375V5.25H3.9375V18.375C3.9375 18.7231 4.07578 19.0569 4.32192 19.3031C4.56806 19.5492 4.9019 19.6875 5.25 19.6875H15.75C16.0981 19.6875 16.4319 19.5492 16.6781 19.3031C16.9242 19.0569 17.0625 18.7231 17.0625 18.375V5.25H18.375V3.9375H2.625ZM5.25 18.375V5.25H15.75V18.375H5.25ZM7.875 1.3125H13.125V2.625H7.875V1.3125Z",
    fill: "#EC827D"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteNotif);
export default __webpack_public_path__ + "static/media/deleteNotif.5407774040392e45f27d545ae8a2fc28.svg";
export { ForwardRef as ReactComponent };